import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.paddings(20, 10),
  width: 320,
  backgroundColor: theme.palette.white,
  boxShadow: `0 1px 5px ${theme.palette.shadow.medium}`,
  position: "relative",

  [theme.down("xl")]: {
    width: 280,
  },

  [theme.down("md")]: {
    width: 210,
  },

  [theme.down("sm")]: {
    width: "100%",
  },
}));

export const PricesBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 10,
  alignItems: "center",
  // position: "sticky",
  // top: 60,
}));

export const SubmitButton = styled("button")(({ theme }) => ({
  ...theme.paddings(5, 10),
  width: 170,
  height: 42,
  color: theme.palette.white,
  backgroundColor: theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.main}`,
  fontSize: 14,
  cursor: "pointer",
  transition: "all 0.3s ease-out",

  "&:hover": {
    backgroundColor: theme.palette.hoverButtonBg,
    border: `1px solid ${theme.palette.primary.dark}`,
  },
}));

export const Timelimit = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 3,
  fontSize: 18,

  "& > span": {
    color: theme.palette.text.secondary,
    fontSize: 12,
    lineHeight: "14px",
  },
}));

export const TariffItem = styled("div")(({ theme }) => ({
  ...theme.paddings(10, 0),
  ...theme.mixins.flexColumn,
  alignItems: "center",
  justifyContent: "center",
  gap: 10,
  width: "100%",
}));

export const TariffsButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  fontSize: 16,
  border: "none",
  backgroundColor: "transparent",
  cursor: "pointer",
  color: theme.palette.text.secondary,
  gap: 5,

  "& > span": {
    display: "flex",
    fontSize: 16,
  },

  "& > span.active": {
    transform: "rotate(180deg)",
  },
}));
